import { useLoad } from "@redotech/react-util/load";
import { createContext, useContext } from "react";
import { RedoShopifyRpcClientContext } from "../client/redo-shopify-rpc-client";
import { log } from "../monitoring/log";

export const StarRatingsContext = createContext<
  | Record<string, { rating: number; numReviews: number } | null>
  | null
  | undefined
>(null);

export function StarRatingsProvider({
  children,
  productIds,
}: {
  children: React.ReactNode;
  productIds: string[];
}) {
  const rpcClient = useContext(RedoShopifyRpcClientContext);

  const ratings = useLoad(async () => {
    if (!rpcClient) return {};

    try {
      const uniqueProductIds = [...new Set(productIds)];
      log(`Fetching ratings for ${uniqueProductIds.length} products`);
      const result =
        await rpcClient.getProductsReviewsRatings(uniqueProductIds);
      return result;
    } catch (err) {
      log(`Error fetching ratings: ${err}`);
      return {};
    }
  }, [rpcClient, productIds]);

  return (
    <StarRatingsContext.Provider value={ratings.value}>
      {children}
    </StarRatingsContext.Provider>
  );
}
